import { cvaMerge, VariantProps } from '@payaca/utilities/cvaMerge';

export const avatarVariants = cvaMerge(
  'inline-block cursor-default align-middle',
  {
    variants: {
      size: {
        xxs: 'h-6 w-6',
        xs: 'h-8 w-8',
        sm: 'h-10 w-10',
        md: 'h-12 w-12',
        lg: 'h-16 w-16',
        xl: 'h-28 w-28',
      },
      border: {
        white: 'ring-2 ring-white',
        gray: 'ring-2 ring-gray-200',
        blue: 'ring-2 ring-blue-500',
        none: 'ring-0',
      },
      shape: {
        rounded: 'rounded-lg',
        circle: 'rounded-full',
      },

      icon: {
        xxs: 'size-3 ',
        xs: 'size-4',
        sm: 'size-5',
        md: 'size-6',
        lg: 'size-8',
        xl: 'size-9',
      },
    },
    defaultVariants: {
      size: 'md',
      border: 'gray',
      shape: 'circle',
    },
  }
);

export const avatarTextVariants = cvaMerge(
  'font-medium uppercase leading-none text-white',
  {
    variants: {
      size: {
        xxs: 'text-xs',
        xs: 'text-xs',
        sm: 'text-sm',
        md: 'text-base',
        lg: 'text-lg',
        xl: 'text-4xl',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }
);
export type TIconSizeVariant = NonNullable<
  VariantProps<typeof avatarVariants>['icon']
>;
export type TAvatarVariants = VariantProps<typeof avatarVariants>;
export type TAvatarSizeVariant = NonNullable<TAvatarVariants['size']>;
export type TAvatarBorderColourVariant = NonNullable<TAvatarVariants['border']>;
export type TAvatarStyleVariant = NonNullable<TAvatarVariants['shape']>;
